import * as React from 'react';

import { Button, Dialog, DialogContent, DialogTitle, Stack, Typography } from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';
import ApprovalIcon from '@mui/icons-material/Approval';

export const UserMessageConfirmationModal = ({ title, userMessage, inputId, processConfirmation, openState, setOpenState }:
    {
        title?: string,
        userMessage: string,
        inputId: number,
        openState: boolean,
        processConfirmation: (rowId: number) => void
        setOpenState: React.Dispatch<React.SetStateAction<boolean>>
    }) => {

    const handleClose = () => {
        setOpenState(false);
    }

    const onConfirm = () => {
        processConfirmation(inputId);
        setOpenState(false);
    }

    return <Dialog open={openState} onClose={handleClose} fullWidth maxWidth={'md'}>
        <DialogTitle>
            {title ? title : "Please Confirm"}
        </DialogTitle>

        <DialogContent>
            <Stack direction='column' spacing={20}>
                <Typography variant='body2' display={!userMessage ? 'none' : 'block'}>{userMessage}</Typography>
                <Stack direction='row' display={'flex'} justifyContent='space-between'>
                    <Button onClick={handleClose} startIcon={<CancelIcon />}>{"Cancel"}</Button>
                    <Button onClick={() => onConfirm()} startIcon={<ApprovalIcon />}>{"Confirm"}</Button>
                </Stack>
            </Stack>
        </DialogContent>
    </Dialog>
}